<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <sequential-entrance from-top>
      <v-row class="hidden-md-and-down">
        <v-col
          v-for="button in menuforstatus"
          :key="button.nav"
          class="justify-space-around"
        >
          <base-material-card
            v-if="!loading"
            :color="button.color"
            :icon="button.icon"
            inline
            link
            :to="gettopurl(button.nav)"
          >
            <template v-slot:after-heading>
              <div class="display-1 font-weight-light">
                {{ button.text }}
              </div>
            </template>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-truck"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                In House banking {{ sitedetails.idnum }}
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getinhouseshipments"
              :single-expand="singleExpand"
              :expanded.sync="expanded_deposits"
              :items-per-page="10"
              :search="search"
              sort-by="timestamp"
              sort-desc
              expand-icon="mdi-information"
              item-key="timestamp"
              show-expand
              class="elevation-1"
              @item-expanded="loadDepositDetails"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Labels</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="warning"
                        dark
                        class="mb-2"
                        to="/Sendbankactions"
                      >
                        Return
                      </v-btn><v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        v-on="on"
                      >
                        New Shipment
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              {{ sitedetails.idnum }}
                            </v-col>
                            <v-col>
                              <v-data-table
                                v-model="selected"
                                :headers="bagheaders"
                                :items="getsecurebagdeposits"
                                :single-select="singleSelect"
                                item-key="timestamp"
                                show-select
                              >
                                <template v-slot:[`item.securebagdeposit.DepositAmount`]="{ item }">
                                  {{ format_amt(item.securebagdeposit.DepositAmount) }}
                                </template>
                              </v-data-table>
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Package Total is <b>{{ totalShipment }}</b>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Shipment Insruance Limit is <b>$5,000.00</b>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Shipping Address Info: {{ sitedetails.address }}, {{ sitedetails.city }} {{ sitedetails.state }} {{ sitedetails.zipcode }}
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Contact: {{ sitedetails.sitecontactname }}, {{ sitedetails.sitecontactnumber }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="saveinhouseshipment"
                        >
                          Create
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>

              <template v-slot:[`item.carrier`]="{ item }">
                USPS
              </template>
              <template v-slot:[`item.label`]="{ item }">
                <a
                  :href="getlabelpdfurl(item)"
                  target="_blank"
                >
                  <v-icon color="red">mdi-pdf-box</v-icon><v-icon>mdi-download</v-icon>
                </a>
              </template>
              <template v-slot:[`item.manifest`]="{ item }">
                <v-btn
                  outlined
                  small
                  color="deep-purple darken-1"
                  dark
                  @click="generatepdf(item)"
                >
                  <v-icon color="red">
                    mdi-pdf-box
                  </v-icon><v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.timestamp`]="{ item }">
                {{ format_time(item.timestamp) }}
              </template>

              <template v-slot:[`item.amount`]="{ item }">
                {{ format_amt(item.postaldeposit.DepositAmount) }}
              </template>
              <template v-slot:[`item.bagid`]="{ item }">
                {{ item.postaldeposit.BagNumber }}
              </template>
              <template v-slot:[`item.trackingnumber`]="{ item }">
                {{ item.tracking_number }}
              </template>
              <template v-slot:[`item.vaultstatus`]="{ item }">
                Delivered
              </template>
              <template v-slot:no-data>
                Sorry, No info {{ sitedetails.idnum }}
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td
                  :colspan="headers.length"
                  class="white"
                >
                  <v-card
                    elevation="2"
                    outlined
                  >
                    <v-card-text class="title">
                      <v-row>
                        <v-col
                          class="ma-0"
                          cols="6"
                        >
                          <v-card-text>
                            <vue-web-cam
                              ref="webcam"
                              :device-id="deviceId"
                              screenshot-format="image/jpeg"
                              @started="onStarted"
                              @stopped="onStopped"
                              @error="onError"
                              @cameras="onCameras"
                              @camera-change="onCameraChange"
                            />
                          </v-card-text>
                          <v-card-text>
                            <v-row
                              class="pa-2 ma-2 justify-space-around"
                            >
                              <v-btn
                                dark
                                outlined
                                color="indigo"
                                @click="onCapture(item)"
                              >
                                Scan Slip
                              </v-btn>
                              <v-btn
                                dark
                                outlined
                                color="indigo"
                                @click="onStart"
                              >
                                Start Camera
                              </v-btn>
                              <v-btn
                                dark
                                outlined
                                color="indigo"
                                @click="onStop"
                              >
                                Stop Camera
                              </v-btn>
                            </v-row>
                          </v-card-text>
                        </v-col>
                        <v-col
                          class="ma-0"
                          cols="6"
                        >
                          <v-row>
                            <v-col
                              cols="12"
                            >
                              <div>
                                <!-- all props & events -->
                                <vue-easy-lightbox
                                  esc-disabled
                                  move-disabled
                                  :visible="visible"
                                  :imgs="imgs"
                                  :index="index"
                                  @hide="handleHide"
                                >
                                  <template #toolbar="{ toolbarMethods }">
                                    <v-btn
                                      class="warning"
                                      x-large
                                      @click="toolbarMethods.zoomIn"
                                    >
                                      zoom in
                                    </v-btn>
                                    <v-btn
                                      class="warning"
                                      x-large
                                      @click="toolbarMethods.zoomOut"
                                    >
                                      zoom out
                                    </v-btn>
                                    <v-btn
                                      class="warning"
                                      x-large
                                      @click="toolbarMethods.rotateLeft"
                                    >
                                      Anticlockwise rotation
                                    </v-btn>
                                    <v-btn
                                      class="warning"
                                      x-large
                                      @click="toolbarMethods.rotateRight"
                                    >
                                      clockwise rotation
                                    </v-btn>
                                  </template>
                                </vue-easy-lightbox>
                              </div>
                              <v-row class="wrap">
                                <v-img
                                  v-for="(imageUrl, i) in listDepositImages"
                                  :key="i"
                                  :src="imageUrl"
                                  aspect-ratio="1"
                                  contain
                                  width="175"
                                  height="125"
                                  @click="showSingle(i)"
                                />
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </td>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format, zonedTimeToUtc } from 'date-fns-tz'
  import { jsPDF } from 'jspdf'
  const axios = require('axios')
  var numeral = require('numeral')
  var jrQrcode = require('jr-qrcode')

  export default {

    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      activecam: false,
      imgs: '',
      visible: false,
      index: 0,
      id_images: [
        { img: '/img/id_front.jpg', type: 'front', set: false },
        { img: '/img/id_back.jpg', type: 'back', set: false },
      ],
      lightboxImages: [],
      img_data_front: null,
      img_data_back: null,
      id_front: '/img/id_front.jpg',
      id_back: '/img/id_back.jpg',
      camera: null,
      deviceId: null,
      devices: [],
      camimg: '',
      dialog: false,
      selected: [],
      loading: false,
      sitedetails: '',
      snackbar: false,
      unit_id: '',
      timeout: 7000,
      singleSelect: false,
      search: '',
      alertmessage: '',
      headers: [
        { text: 'Created', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'trackingnumber', sortable: true },
        { text: 'Manifest', align: 'center', value: 'manifest', sortable: true },
        { text: 'Count', align: 'center', value: 'count', sortable: true },
        { text: 'Amount', align: 'center', value: 'amt', sortable: true },
        { text: 'Status', align: 'center', value: 'vaultstatus', sortable: true },
      ],
      bagheaders: [
        { text: 'Bag ID', align: 'center', value: 'securebagdeposit.BagNumber', sortable: true },
        { text: 'Deposit Amount', align: 'center', value: 'securebagdeposit.DepositAmount', sortable: true },
      ],
      alerts: [],
      depositusers: [],
      expanded: [],
      expanded_deposits: [],
      singleExpand: true,
      editedIndex: -1,
      editedItem: {
        safeid: '',
        bags: [],
        idnum: '',
        timestamp: '',
        allowedusers: '',
        duration: '',
        washifyid: '',
        source: '',
        status: '',
        userid: '',
        amount: '',
      },
      defaultItem: {
        safeid: '',
        idnum: '',
        bags: [],
        timestamp: '',
        duration: '',
        allowedusers: '',
        washifyid: '',
        status: '',
        userid: '',
        amount: '',
        source: '',
      },
      gallery: []
    }),

    computed: {
      listDepositImages () {
        this.id_images = [
          { img: '/img/id_front.jpg', type: 'front', set: false },
          { img: '/img/id_back.jpg', type: 'back', set: false },
        ]
        let imageUrls = []
        this.gallery = []
        imageUrls = this.$store.getters.getDepositImages
        imageUrls.forEach(entry => {
          this.gallery.push({ src: entry })
        })
        return imageUrls
      },
      togglecam () {
        if (this.activecam) {
          this.activecam = false
          return
        }
        this.activecam = true
      },
      getfrontimge () {
        return this.id_images[0].img
      },
      getbackimage () {
        return this.id_images[1].img
      },
      device: function () {
        return this.devices.find(n => n.deviceId === this.deviceId)
      },
      menuforstatus () {
        if (this.$store.getters.user.status === 'storemanager') {
          return []
        } else if (this.$store.getters.user.status === 'groupmanager') {
          return []
        } else if (this.$store.getters.user.status === 'corporate') {
          return [
            {
              text: 'Create Bags',
              value: 'deposits',
              color: 'pink',
              icon: 'mdi-shopping-outline',
              nav: '/Inhousedeposit/'
            },
            {
              text: 'Tracking',
              value: 'cit',
              color: 'green',
              icon: 'mdi-transfer-right',
              nav: '/Inhousetracking/'
            },
          ]
        } else if (this.$store.getters.user.status === 'admin') {
          return [
            {
              text: 'Create Bags',
              value: 'deposits',
              color: 'pink',
              icon: 'mdi-shopping-outline',
              nav: '/Inhousedeposit/'
            },
            {
              text: 'Tracking',
              value: 'cit',
              color: 'green',
              icon: 'mdi-transfer-right',
              nav: '/Inhousetracking/'
            },
          ]
        }
      },
      formIsValid () {
        return this.editedItem.email !== '' &&
          this.editedItem.accesscode !== '' &&
          this.editedItem.username !== ''
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Shipment' : 'Edit Label in Transit'
      },
      getsecurebagdeposits () {
        let securebags = this.$store.getters.getLoadedSecureBagDeposits
        return securebags.filter(deposit => deposit.shipped != true)
      },
      totalShipment () {
        let total = 0
        this.selected.forEach(item => {
          total += parseFloat(item.securebagdeposit.DepositAmount)
        })
        return numeral(total).format('$0.00')
      },
      getinhouseshipments () {
        let recs = this.$store.getters.getLoadedInHouseShipments
        for (let record of recs) {
          let sum = 0
          record.contents.forEach(item => {
            sum += parseFloat(item.securebagdeposit.DepositAmount)
          })
          Object.assign(record, { count: record.contents.length })
          Object.assign(record, { amt: numeral(sum).format('$0.00') })
        }
        // get count of the contents
        // get total amount of the bags
        return recs
      },

      getshipments () {

      }
    },

    watch: {
      camera: function (id) {
        this.deviceId = id
      },
      devices: function () {
        // Once we have a list select the first one
        const [first, ...tail] = this.devices
        if (first) {
          this.camera = first.deviceId
          this.deviceId = first.deviceId
        }
      },
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
      this.initialize()
    },
    beforeDestroy () {
      // this.$store.dispatch('stoprealtimepostalshipments', this.id)
    },
    methods: {
      showSingle (index) {
        this.imgs = this.$store.getters.getDepositImages[index]
        // or
        this.show()
      },
      showMultiple () {
        this.imgs = ['http://via.placeholder.com/350x150', 'http://via.placeholder.com/350x150']
        // or
        this.imgs = [
          { title: 'test img', src: 'http://via.placeholder.com/350x150' },
          'http://via.placeholder.com/350x150'
        ]
        // allow mixing

        this.index = 1 // index of imgList
        this.show()
      },
      show () {
        this.visible = true
      },
      handleHide () {
        this.visible = false
      },
      loadDepositDetails ({ item }) {
        console.log('this was expanded ', item)
        let depositRec = {
          sitekey: this.sitedetails.sitekey,
          trackingnumber: item.tracking_number
        }
        this.$store.dispatch('listCloudDepositImagesAsync', depositRec)
      },
      onCapture (item) {
        console.log('item passed ', item)
        this.img = this.$refs.webcam.capture()
        let imageRec = {
          img: this.img,
          sitekey: this.sitedetails.sitekey,
          trackingnumber: item.tracking_number
        }
        this.$store.dispatch('uploadMetadata', imageRec)
        if (this.id_images[0].set === false) {
          console.log('set image front')
          this.id_images[0].set = true
          this.id_images[0].img = this.img
          this.img_data_front = this.img
        } else {
          console.log('set image back')
          this.id_images[1].set = true
          this.id_images[1].img = this.img
          this.id_images[0].set = false
        // this.id_images[1] =
        }

      // console.log('image is ', this.img)
      },
      onStarted (stream) {
        console.log('On Started Event', stream)
      },
      onStopped (stream) {
        console.log('On Stopped Event', stream)
      },
      onStop () {
        this.$refs.webcam.stop()
      },
      onStart () {
        this.$refs.webcam.start()
      },
      onError (error) {
        console.log('On Error Event', error)
      },
      onCameras (cameras) {
        this.devices = cameras
        console.log('On Cameras Event', cameras)
      },
      onCameraChange (deviceId) {
        this.deviceId = deviceId
        this.camera = deviceId
        console.log('On Camera Change Event', deviceId)
      },
      onDismissed () {
        this.clientwarned = true
        this.$store.dispatch('clearError')
      },
      onDecode (result) {
        this.result = result
      },
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.loadedPendingDeposits
      },
      gettopurl (nav) {
        let url = nav + this.id
        return url
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('YYYY-MM-DD, HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      getlabelpdfurl (data) {
        let url = ''
        if (data.label_download) {
          url = data.label_download.pdf
        }
        return url
      },
      generatepdf (item) {
        const doc = new jsPDF()
        doc.setFontSize(22)
        doc.text('Paythings Security Bag Manifest', doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' })
        doc.text('Please include this inside the package', doc.internal.pageSize.getWidth() / 2, 30, { align: 'center' })
        doc.text(item.siteid, doc.internal.pageSize.getWidth() / 2, 40, { align: 'center' })
        doc.text('Security Bag count: ' + item.contents.length, doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' })
        // loop through security bags in this package
        let step = 10
        let ypos = 70
        item.contents.forEach(secbag => {
          let bagidlist = ''
          let pos = ypos + step
          ypos += step
          bagidlist += 'Bag ID ' + secbag.securebagdeposit.BagNumber
          doc.text(bagidlist, 55, pos, { align: 'center' })
        })

        let imgBase64 = jrQrcode.getQrBase64(item.trackingnumber)
        doc.addImage(imgBase64, 'JPEG', 110, 70, 75, 75)

        doc.save(item.siteid + '.pdf')
        this.alertmessage = 'Downloading Manifest code for ' + item.siteid
        this.snackbar = true
      },
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }
        }
        this.$store.dispatch('loadsecuritybagdeposits', machineid)
        this.$store.dispatch('loadinhouseshipments', machineid)
        // this.$store.dispatch('initrealtimepostalshipments', machineid)
      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.id
          }
          this.$store.dispatch('removePendingDeposit', rec)
        }
      },
      close () {
        this.dialog = false
        this.selected = []
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      saveinhouseshipment () {
        let postaldeposit = { Name: 'Unsent', Amount: '0' } // we dont know whats in the bag yet
        let pickupday = moment().add(1, 'day').format('YYYY-MM-DD')
        let timezone = 'America/New_York'
        let tstart = pickupday + ' ' + '12:00'
        let tend = pickupday + ' ' + '16:00'
        let start = zonedTimeToUtc(tstart, timezone)
        let end = zonedTimeToUtc(tend, timezone)
        let rec = {
          siteid: this.sitedetails.idnum,
          safeid: this.id,
          contents: this.selected,
          used: false,
          postaldeposit: '',
          timestamp: Date.now(),
          pickupstart: start.toISOString(),
          pickupend: end.toISOString(),
          sitedetails: this.sitedetails
        }
        this.editedItem = this.defaultItem // reset values
        this.alertmessage = 'Your deposit has been recorded'
        this.snackbar = true
        this.$store.dispatch('createInHouseBankPackage', rec)
        this.dialog = false
        // this.$store.dispatch('loadpostalshipments', this.id)

        //  this.$store.dispatch('loadpostaldeposits', this.id)
        // this.$store.dispatch('loadpostaldeposits', this.$route.params.id)
      },
    },
  }
</script>
